export enum AlertTypes {
  SUCCESS = "SUCCESS",
  WARNING = "WARNING",
  ERROR = "ERROR",
}

export interface AlertProps {
  title?: string
  message: string
  onClose?: () => void
}
